(() => {
  if (window.KovyqCart) return;
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/';
  const drawer = () => document.querySelector('[data-adev-drawer="cart-drawer"]');
  const sectionId = () => drawer()?.dataset.section || 'adev-cart-drawer';
  let activeElement;
  let queue = Promise.resolve();
  let refreshVersion = 0;
  const api = window.KovyqCart = {
    open(trigger) {
      const panel = drawer();
      if (!panel) return;
      if (trigger) activeElement = trigger;
      panel.classList.add('adev-opened');
      panel.removeAttribute('inert');
      panel.setAttribute('aria-hidden', 'false');
      document.querySelector('[data-adev-drawer-overlay]')?.classList.add('adev-opened');
      document.documentElement.classList.add('adev-noscroll');
      api.measure();
      panel.querySelector('[data-adev-close-drawer]')?.focus();
    },
    close() {
      const panel = drawer();
      panel?.classList.remove('adev-opened');
      panel?.setAttribute('inert', '');
      panel?.setAttribute('aria-hidden', 'true');
      document.querySelector('[data-adev-drawer-overlay]')?.classList.remove('adev-opened');
      document.documentElement.classList.remove('adev-noscroll');
      if (activeElement?.isConnected) activeElement.focus();
    },
    measure() {
      const height = drawer()?.querySelector('[data-adev-cart-drawer-footer]')?.offsetHeight || 0;
      document.documentElement.style.setProperty('--adev-cart-drawer-footer-height', height + 'px');
    },
    async refresh(sections) {
      const version = ++refreshVersion;
      const id = sectionId();
      if (!sections?.[id]) {
        const response = await fetch(root() + '?sections=' + encodeURIComponent(id + ',cart-icon-bubble'), { cache: 'no-store' });
        if (!response.ok) throw new Error(drawer()?.dataset.error || 'Could not refresh cart.');
        sections = await response.json();
      }
      if (version !== refreshVersion) return;
      const fresh = new DOMParser().parseFromString(sections[id] || '', 'text/html').querySelector('[data-adev-cart-drawer-contents]');
      const current = drawer()?.querySelector('[data-adev-cart-drawer-contents]');
      if (!fresh || !current) throw new Error(drawer()?.dataset.error || 'Could not refresh cart.');
      const scroll = current.querySelector('.adev-cart-drawer__items')?.scrollTop || 0;
      const focused = document.activeElement;
      const focusKey = focused?.closest('[data-adev-cart-item]')?.querySelector('[data-key]')?.dataset.key;
      const focusSelector = focused?.matches('[data-adev-quantity-up]') ? '[data-adev-quantity-up]' : focused?.matches('[data-adev-quantity-down]') ? '[data-adev-quantity-down]' : null;
      current.innerHTML = fresh.innerHTML;
      if (drawer()?.getAttribute('aria-busy') === 'true') api.busy(true);
      const scroller = current.querySelector('.adev-cart-drawer__items');
      if (scroller) scroller.scrollTop = scroll;
      if (sections['cart-icon-bubble']) {
        const bubble = document.querySelector('#cart-icon-bubble');
        const fragment = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const content = fragment.querySelector('#cart-icon-bubble') || fragment.querySelector('.shopify-section');
        if (bubble && content) bubble.innerHTML = content.innerHTML;
      }
      const count = current.querySelector('[data-adev-count]')?.dataset.adevCount || '0';
      document.querySelectorAll('[data-cart-item-count]').forEach(element => element.textContent = count);
      api.measure();
      if (drawer()?.classList.contains('adev-opened') && !focused?.isConnected) {
        const line = Array.from(current.querySelectorAll('[data-adev-cart-item]')).find(element => element.querySelector('[data-key]')?.dataset.key === focusKey);
        (line?.querySelector(focusSelector || '[data-adev-remove-cart-drawer-item]') || drawer().querySelector('[data-adev-close-drawer]'))?.focus();
      }
    },
    busy(value) {
      const panel = drawer();
      panel?.setAttribute('aria-busy', String(value));
      panel?.querySelectorAll('[data-adev-cart-drawer-contents] button, [data-adev-cart-drawer-contents] input, [data-adev-cart-drawer-contents] select').forEach(element => {
        if (value) { if (!('kqWasDisabled' in element.dataset)) element.dataset.kqWasDisabled = String(element.disabled); element.disabled = true; }
        else if ('kqWasDisabled' in element.dataset) { element.disabled = element.dataset.kqWasDisabled === 'true'; delete element.dataset.kqWasDisabled; }
      });
    },
    mutate(endpoint, body) {
      const operation = queue.then(async () => {
        api.busy(true);
        let saved = false;
        try {
          const response = await fetch(root() + 'cart/' + endpoint + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ...body, sections: [sectionId(), 'cart-icon-bubble'], sections_url: window.location.pathname })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || drawer()?.dataset.error);
          saved = true;
          await api.refresh(result.sections);
          return result;
        } catch (error) {
          error.cartSaved = saved;
          const status = drawer()?.querySelector('[data-kq-cart-status]');
          if (status) status.textContent = saved ? drawer().dataset.refreshError : error.message;
          throw error;
        } finally { api.busy(false); }
      });
      queue = operation.catch(() => {});
      return operation;
    }
  };
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', class extends HTMLElement {
    open(trigger) { api.open(trigger); }
    close() { api.close(); }
    setActiveElement(element) { activeElement = element; }
    getSectionsToRender() { return [{ id: sectionId() }, { id: 'cart-icon-bubble' }]; }
    renderContents(result) { api.refresh(result.sections).then(() => api.open()).catch(() => api.open()); }
  });
  document.addEventListener('click', event => {
    const target = event.target.closest('button, a, [data-adev-drawer-overlay]');
    if (!target) return;
    if (target.matches('[data-adev-atc-variant-id]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (target.classList.contains('loading')) return;
      target.classList.add('loading');
      api.mutate('add', { items: [{ id: Number(target.dataset.adevAtcVariantId), quantity: 1 }] })
        .then(() => api.open(target)).catch(() => api.open(target)).finally(() => target.classList.remove('loading'));
      return;
    }
    if (target.matches('#cart-icon-bubble, [data-adev-open-drawer="cart-drawer"]')) {
      event.preventDefault(); event.stopImmediatePropagation(); api.open(target); return;
    }
    if (target.matches('[data-adev-close-drawer], [data-adev-drawer-overlay]')) {
      event.preventDefault(); event.stopImmediatePropagation(); api.close(); return;
    }
    if (!target.closest('[data-adev-drawer="cart-drawer"]')) return;
    if (target.matches('[data-adev-quantity-up], [data-adev-quantity-down], [data-adev-remove-cart-drawer-item]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (target.disabled || drawer().getAttribute('aria-busy') === 'true') return;
      const line = target.closest('[data-adev-cart-item]');
      const key = line.querySelector('[data-key]').dataset.key;
      const input = line.querySelector('[data-adev-quantity-value]');
      const quantity = target.matches('[data-adev-remove-cart-drawer-item]') ? 0 : Math.max(0, Number(input.value) + (target.matches('[data-adev-quantity-up]') ? 1 : -1));
      api.mutate('change', { id: key, quantity }).catch(() => {});
    }
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-adev-cart-drawer-form] [data-adev-quantity-value]')) return;
    event.stopImmediatePropagation();
    const key = event.target.closest('[data-adev-cart-item]').querySelector('[data-key]').dataset.key;
    const quantity = Math.max(0, Math.floor(Number(event.target.value) || 0));
    api.mutate('change', { id: key, quantity }).catch(() => {});
  }, true);
  document.addEventListener('keydown', event => {
    if (event.target.closest('#cart-icon-bubble') && [' ', 'Enter'].includes(event.key)) { event.preventDefault(); api.open(event.target); return; }
    const panel = drawer();
    if (!panel?.classList.contains('adev-opened')) return;
    if (event.key === 'Escape') { event.preventDefault(); api.close(); }
    if (event.key === 'Tab') {
      const controls = Array.from(panel.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled)')).filter(element => element.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  const init = () => {
    api.measure();
    const panel = drawer();
    if (panel && !panel.classList.contains('adev-opened')) { panel.setAttribute('inert', ''); panel.setAttribute('aria-hidden', 'true'); }
    if (window.jQuery) {
      const $ = window.jQuery;
      $(document).off('.kqCart').on('adev:cart:drawer:refresh.kqCart', (event, sections) => api.refresh(sections).catch(() => {}))
        .on('adev:open:drawer.kqCart', (event, name) => { if (name === 'cart-drawer') api.open(); })
        .on('adev:close:drawer.kqCart', () => api.close());
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  window.addEventListener('resize', api.measure);
})();


  if (!customElements.get('kq-cart-recommendations')) {
    customElements.define(
      'kq-cart-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;

          this.addEventListener('change', event => {
            if (event.target.matches('[data-option]')) {
              this.updateVariant(
                event.target.closest('.kq-card')
              );
            }
          });

          this.addEventListener('click', event => {
            const arrow = event.target.closest(
              '[data-direction]'
            );

            if (arrow) {
              const track = this.querySelector('.kq-carousel');

              const distance =
                track.firstElementChild?.offsetWidth + 12 || 240;

              track.scrollBy({
                left: Number(arrow.dataset.direction) * distance,
                behavior: matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches ? 'auto' : 'smooth'
              });
            }

            const button = event.target.closest('.kq-add');

            if (button && !button.disabled) {
              this.addVariant(button);
            }
          });
        }

        updateVariant(card) {
          const variants = JSON.parse(
            card.querySelector('[data-variants]').textContent
          );

          const selected = Array.from(
            card.querySelectorAll('[data-option]'),
            select => select.value
          );

          const variant = variants.find(candidate =>
            candidate.options.every(
              (value, index) => value === selected[index]
            )
          );

          const button = card.querySelector('.kq-add');

          button.disabled = !variant?.available;
          button.dataset.variant = variant?.id || '';

          button.textContent = variant
            ? (
                variant.available
                  ? this.dataset.add
                  : this.dataset.sold
              )
            : this.dataset.unavailable;

          if (variant) {
            card.querySelector('.kq-price').textContent =
              variant.price;

            const image = card.querySelector('img');

            if (image && variant.image) {
              image.removeAttribute('srcset');
              image.src = variant.image;
            }
          }
        }

        async addVariant(button) {
          if (this.busy) return;
          this.busy = true;
          const status = this.querySelector('.kq-status');
          status.textContent = '';
          button.textContent = this.dataset.adding;
          try {
            await window.KovyqCart.mutate('add', { items: [{ id: Number(button.dataset.variant), quantity: 1 }] });
            const nextStatus = document.querySelector('[data-adev-drawer="cart-drawer"] .kq-related .kq-status');
            if (nextStatus) nextStatus.textContent = this.dataset.added;
          } catch (error) {
            status.textContent = error.cartSaved ? this.dataset.refreshError : error.message || this.dataset.error;
            if (error.cartSaved) button.disabled = true;
          } finally {
            this.busy = false;
            button.textContent = this.dataset.add;
          }
        }
      }
    );
  }

